<template>
  <div></div>
</template>

<script>
export default {
  name: "NotFoundComponent"
};
</script>

<style scoped></style>
